import * as types from "./types";

const mutations = {
    [types.UPDATE_LAST_SWATCH_APPLIED](state, payload) {
        state.lastSwatchApplied = { ...state.lastSwatchApplied, ...payload };
    },
    [types.UPDATE_PREVIOUS_SWATCH](state, payload) {
        state.previousSwatch = [...payload];
    },
    [types.CLEAN_UNDO](state) {
        state.feature = null;
        state.previousSwatch = [];
        state.previousRecipe = {};
    },
    [types.UPDATE_PREVIOUS_RECIPE](state, payload) {
        state.feature = payload.feature || null;
        state.previousRecipe = { ...payload.recipe };
    },
    [types.CLEAN_RECIPE](state) {
        state.previousRecipe = {};
    },
    [types.HAS_UNDO_BEEN_APPLIED](state, payload) {
        state.hasUndoBeenApplied = payload;
    },
    [types.COMPONENTS](state, payload) {
        state.components.add(payload);
    },
    [types.INIT_COMPONENTS](state) {
        state.components = new Set();
    }
};

export default mutations;